import Vue from 'vue';
import VueRouter from 'vue-router';
import createAuthorizationMiddleware from '@/authorization/authorization-middleware';

//components
import Samples from '@/pages/samples';

//system
import Access_Denied from '@/pages/access-denied';
import NotFound from '@/pages/not-found';
import OidcCallback from '@/pages/oidc-callback';
import OidcCallbackError from '@/pages/oidc-callback-error';
import OidcSilentRenew from '@/pages/oidc-silent-renew-page';

//extra routes
import ExtraRouters from '@/lib/loader-routes';

let routes = [
	{
		name: 'samples',
		path: '/samples',
		component: Samples,
		meta: {
			isPublic: true
		}
	},
	//system
	{
		path: '/',
		name: 'default',
		redirect: {
			path: '/clients'
		}
	},
	{
		name: 'oidcCallback',
		path: '/oidc-callback',
		component: OidcCallback,
		meta: {
			isPublic: true
		}
	},
	{
		path: '/oidc-callback-error',
		name: 'oidcCallbackError',
		component: OidcCallbackError,
		meta: {
			isPublic: true
		}
	},
	{
		path: '/oidc-silent-renew',
		name: 'oidc-silent-renew',
		component: OidcSilentRenew,
		meta: {
			isPublic: true
		}
	},
	{
		name: 'access-denied',
		path: '/access-denied',
		component: Access_Denied,
		meta: {
			isPublic: true
		}
	},
	{
		path: '*',
		component: NotFound,
		meta: {
			isPublic: true
		}
	}
];

ExtraRouters.forEach(items => {
	if (items) {
		routes.unshift(...items);
	}
});

Vue.use(VueRouter);
const router = new VueRouter({
	mode: 'history',
	routes,
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition;
		} else {
			return { top: 0 };
		}
	}
});
router.beforeEach(createAuthorizationMiddleware('oidcStore'));

export default router;
